import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {Vehicle} from "domain-models"
import React from "react"
import {number, vehicleAttribute} from "../../../../../filters"
import Trans from '../../../../../components/Trans'
import Consumptions from './Consumptions'

type EnvironmentProps = {
  vehicle: Vehicle
}

class Environment extends React.Component<EnvironmentProps> {
  render() {
    const vehicle = this.props.vehicle
    return (
      <div className="w-full flex flex-row flex-wrap mt-10 md:mt-0 text-gray-700">
        <span className='font-semibold text-lg text-gray-700 w-full'>
          <Icon icon={['fas', 'leaf']}/> <Trans>Umwelt</Trans>
        </span>

        <div className='flex flex-row flex-wrap w-full'>
          <span className='w-1/2 lg:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Emissionsgruppe</Trans></span>
            <span className="font-semibold text-gray-800">{vehicleAttribute('EmissionGroup', vehicle.EmissionGroup)}</span>
          </span>

          <span className='w-1/2 lg:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Umweltplakette</Trans></span>
            <span className="font-semibold text-gray-800">{vehicleAttribute('EmissionsBadge', vehicle.EmissionsBadge)}</span>
          </span>

          <span className='w-1/2 lg:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Effizienzklasse</Trans></span>
            <span className="font-semibold text-gray-800">{vehicleAttribute('EfficiencyClass', vehicle.EfficiencyClass)}</span>
          </span>

          <span className='w-1/2 lg:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Reifeneffizienzklasse</Trans></span>
            <span className="font-semibold text-gray-800">{vehicleAttribute('TireEfficiencyClass', vehicle.TireEfficiencyClass)}</span>
          </span>

          <span className='w-1/2 lg:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Hybrid-Stromverbrauch</Trans></span>
            <span className="font-semibold text-gray-800">{number(vehicle.ConsumHybridElectro, 1, 'kw / 100km')}</span>
          </span>
        </div>

        <Consumptions vehicle={vehicle} />
      </div>
    )
  }
}

export default Environment
